<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    width="700px"
    :before-close="close"
    :title="titles[updateType]"
  >
    <el-form ref="form" :model="initForm" :rules="rules">
      <template v-if="updateType === 'add'">
        <el-form-item label="用户名" prop="username" label-width="180px">
          <el-input v-model="initForm.username" key="username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password1" label-width="180px">
          <el-input
            v-model="initForm.password1"
            show-password
            key="password1"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2" label-width="180px">
          <el-input v-model="initForm.password2" show-password></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email" label-width="180px">
          <el-input v-model="initForm.email"></el-input>
        </el-form-item>
        <el-form-item label="姓名" label-width="180px">
          <el-input v-model="initForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="180px">
          <el-input v-model="initForm.mobile"></el-input>
        </el-form-item>

        <el-form-item label="部门" label-width="180px">
          <el-select v-model="initForm.department" placeholder="请选择">
            <el-option
              style="font-size:16px;"
              v-for="department in departmentGroup"
              :label="department.Name"
              :key="department.ID"
              :value="department.ID"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="角色" label-width="180px">
          <el-select v-model="initForm.roles" multiple placeholder="请选择">
            <el-option
              v-for="role in roleGroup"
              :key="role.ID"
              :label="role.Name"
              :value="role.ID"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="用户名" prop="username" label-width="180px">
          <el-input v-model="initForm.username"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email" label-width="180px">
          <el-input v-model="initForm.email"></el-input>
        </el-form-item>
        <el-form-item label="姓名" label-width="180px">
          <el-input v-model="initForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="180px">
          <el-input v-model="initForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="部门" label-width="180px">
          <el-select v-model="initForm.department" placeholder="请选择">
            <el-option
              style="font-size:16px;"
              v-for="department in departmentGroup"
              :label="department.Name"
              :key="department.ID"
              :value="department.ID"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="角色" label-width="180px">
          <el-select v-model="initForm.roles" multiple placeholder="请选择">
            <el-option
              v-for="role in roleGroup"
              :key="role.ID"
              :label="role.Name"
              :value="role.ID"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }
        ],
        password1: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password2: [
          {
            required: true,
            message: "请再次输入密码",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }
        ]
      },
      titles: {
        add: "新增用户",
        edit: "编辑用户"
      }
    };
  },
  computed: {
    departmentGroup() {
      let departmentGroup = this.$store.state.departmentGroup;
      return departmentGroup;
    },
    roleGroup() {
      let roleGroup = this.$store.state.roleGroup;
      return roleGroup;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        if (this.updateType === "edit") {
          let url = "users/" + this.initForm.id + "/";
          this.$http["put"](url, this.initForm, data => {
            this.$baseNotice.message("编辑成功");
            if (this.initForm.id == localStorage.getItem("id")) {
              this.$http.get("account/" + data.data.id + "/", {}, data => {
                localStorage.setItem("department", data.data.department);
                localStorage.setItem("email", data.data.email);
                localStorage.setItem("is_admin", data.data.is_admin);
                localStorage.setItem("mobile", data.data.mobile);
              });
            }
            this.$emit("close");
            this.$emit("update");
          });
        } else {
          let url = "users/";
          this.$http["post"](url, this.initForm, () => {
            this.$baseNotice.message("新增成功");
            this.$emit("close");
            this.$emit("update");
          });
        }
      });
    }
  }
};
</script>
